import { render } from "./OrderCartButton.vue?vue&type=template&id=6322d2c1"
import script from "./OrderCartButton.vue?vue&type=script&lang=js"
export * from "./OrderCartButton.vue?vue&type=script&lang=js"

import "./OrderCartButton.vue?vue&type=style&index=0&id=6322d2c1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInput,QTooltip});
